// src/main.js
import { createApp } from 'vue';
import App from './App.vue';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import VueToastification, { createToastInterface } from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import 'font-awesome/css/font-awesome.min.css'; // Import Font Awesome CSS
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import VueLazyload from 'vue-lazyload';
import router from './router'; // Import the router

const app = createApp(App);

// Register vue-toastification plugin
app.use(VueToastification);
app.use(VueLazyload);

// Use the router
app.use(router);

// Create toast interface
const toastInterface = createToastInterface();

// Set toast interface to global properties
app.config.globalProperties.$toast = toastInterface;

app.mount('#app');
